import React from 'react';

const TermsOfService = () => {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-primary fw-bold">Terms of Service</h2>
      <p>
        These Terms of Service govern your use of CompraPrice. By accessing or using our website, you agree to these terms.
      </p>

      <h5 className="mt-4">1. Use of the Service</h5>
      <p>You agree to use our platform only for lawful purposes and in accordance with these terms.</p>

      <h5 className="mt-4">2. Intellectual Property</h5>
      <p>All content, trademarks, and logos are owned by CompraPrice and may not be used without permission.</p>

      <h5 className="mt-4">3. Limitation of Liability</h5>
      <p>We are not liable for any indirect damages resulting from your use of the service.</p>

      <p className="mt-4">We reserve the right to update these terms at any time.</p>
    </div>
  );
};

export default TermsOfService;
